/**
 * @generated SignedSource<<7f325fc6bad218b462b168b83c7f9a09>>
 * @relayHash 7ece571d05405f0b2cb0416aa92b375d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/571.0.0-2026-08-04T16:01:33.074Z/useItemShippingPricesQuery

import { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type ItemShippingPriceItem = {
  hasPrequote?: boolean | null;
  itemId?: string | null;
  quantity?: number | null;
};
export type useItemShippingPricesQuery$variables = {
  buyerId?: string | null;
  items?: ReadonlyArray<ItemShippingPriceItem | null> | null;
  userCountryCode?: string | null;
  userZipCode?: string | null;
};
export type useItemShippingPricesQuery$data = {
  readonly viewer: {
    readonly itemsShippingPrice: ReadonlyArray<{
      readonly itemId: string | null;
      readonly shipmentQuote: {
        readonly buyerTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
      } | null;
      readonly shipmentQuoteTrackingData: string | null;
    } | null> | null;
  };
};
export type useItemShippingPricesQuery = {
  response: useItemShippingPricesQuery$data;
  variables: useItemShippingPricesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "items"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v4 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "buyerId"
  },
  {
    "kind": "Variable",
    "name": "countryCode",
    "variableName": "userCountryCode"
  },
  {
    "kind": "Variable",
    "name": "items",
    "variableName": "items"
  },
  {
    "kind": "Literal",
    "name": "useLiveEndpoint",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "userZipCode"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shipmentQuoteTrackingData",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "buyerTotalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useItemShippingPricesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "itemsShippingPrice",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useItemShippingPricesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "itemsShippingPrice",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/571.0.0-2026-08-04T16:01:33.074Z/useItemShippingPricesQuery",
    "metadata": {},
    "name": "useItemShippingPricesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "21df034623abe993f7ef4f7825df0204";

export default node;
